import methods from './methods'

export default {
  install: app => {
    app.mixin({
      methods
    })
  }
}
